import { render, staticRenderFns } from "./regenerate-invoice-button.vue?vue&type=template&id=458e38b3"
import script from "./regenerate-invoice-button.vue?vue&type=script&lang=js"
export * from "./regenerate-invoice-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports